import React, { useEffect, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../assets/arrow-left.svg";
import { ReactComponent as LeftArrowDark } from "../../../../../assets/arrow-left-dark.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useStateContext } from "../../../../../contexts/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  updatingHeading,
  resetCardHeading,
} from "../../../../../redux/slices/cards/cardSlice";
import { gettingLinkList } from "../../../../../redux/slices/gettingLinksList/gettingLinkListSlice";
import { toast } from "react-hot-toast";
import HeaderForm from "../forms/HeaderForm";
import {
  deleteBlock,
  resetDeletBlock,
} from "../../../../../redux/slices/block/deleteBlockSlice";
import ConfirmModal from "../../../../../components/dashboard/modal/Confirm";
import useFetchBlock from "../../../../../hooks/useFetchBlock";
import useLocales from "../../../../../hooks/useLocales";
import useSettings from "../../../../../hooks/useSettings";

import SpinnerGiff from "../../../../../assets/spinner.svg";

const EditHeader = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const baseUrl = process.env.REACT_APP_API_URL;
  const { setActiveMainPageNav } = useStateContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { themeDirection } = useSettings();
  const { optionId } = useParams();
  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user.userid;
  const usertoken = user.token;
  const linkId = localStorage.getItem("linkId");
  const linkListData = {
    userId,
    usertoken,
    linkId,
  };
  const [prevData, setPrevData] = useState(null);
  const url = baseUrl + "/api/user/getOption/" + userId + "/" + optionId;

  const { data, loading, error } = useFetchBlock(url);

  useEffect(() => {
    setPrevData({
      ...data?.data,
      coloum_value:
        data?.data?.coloum_value && JSON.parse(data?.data?.coloum_value),
    });
    if (error) {
      toast.error("Something went wrong...");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const [subLoader, setSubLoader] = React.useState(false);

  const handleHeadingTextSubmit = async (data) => {
    const formData = {};
    formData.optionId = optionId;
    formData.coloum_value = data?.coloumnValue;
    formData.coloum_type = data?.coloumnType;
    formData.coloum_name = data?.columnName;
    formData.language = prevData?.language;

    setSubLoader(true);
    await dispatch(updatingHeading(formData)).then(() => {});
    fetchingLinksList(); // fetching link list after submiting , so list become refresh
    setSubLoader(false);
  };
  const fetchingLinksList = () => {
    dispatch(gettingLinkList(linkListData));
  };

  // handling update heading api reponses messages
  const {
    updatedHeadingState,
    headingCardError,
    headingCardSuccess,
    headingCardLoading,
    headingCardErrorMsg,
  } = useSelector((state) => state?.cards?.headingCard);
  useEffect(() => {
    if (updatedHeadingState?.status === "success" && headingCardSuccess) {
      toast.success(updatedHeadingState?.message);
      fetchingLinksList();
      navigate("/dashboard/component");
    }
    if (updatedHeadingState?.status === "failed" && headingCardSuccess) {
      toast.error(updatedHeadingState?.message);
    }
    if (headingCardError && headingCardErrorMsg) {
      toast.error(headingCardErrorMsg?.message);
    }
    dispatch(resetCardHeading());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedHeadingState, headingCardLoading]);

  const deleteHandler = async () => {
    const obj = {
      optionId: optionId,
      userId: userId,
    };
    await dispatch(deleteBlock(obj)).then(() => {});
  };
  const {
    DeleteBlock,
    isDeleteBlockError,
    isDeleteBlockSuccess,
    isDeleteBlockLoading,
    isDeleteBlockErrorMsg,
  } = useSelector((state) => state?.deleteBlock);

  useEffect(() => {
    if (DeleteBlock?.data?.status === "success" && isDeleteBlockSuccess) {
      toast.success(DeleteBlock?.data?.message);
      navigate("/dashboard/component");
    }
    if (DeleteBlock?.data?.status === "failed" && isDeleteBlockSuccess) {
      toast.error(DeleteBlock?.data?.message);
    }
    if (isDeleteBlockError) {
      toast.error(isDeleteBlockErrorMsg);
    }
    dispatch(resetDeletBlock());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDeleteBlockLoading, DeleteBlock]);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleDeleteModal = () => {
    deleteHandler();
    setIsModalOpen(false);
  };

  return (
    <>
      <ConfirmModal
        isOpen={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onConfirm={handleDeleteModal}
        selectedLang={prevData?.language}
      />
      {loading && (
        <div
          style={{ zIndex: "999999" }}
          className="fixed inset-0 h-screen bg-[#ffffffa7] pt-5 flex justify-center items-center overflow-hidden"
        >
          <img src={SpinnerGiff} alt="..." />
        </div>
      )}
      <div className="px-6 md:px-0 mt-[37px] md:mt-0 flex items-center justify-between">
        <Link to={"/dashboard/component"}>
          <div className="flex text-body_copy2 items-center cursor-pointer gap-2">
            <div>
              {darkMode ? (
                <LeftArrowDark
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              ) : (
                <LeftArrow
                  className={`${
                    themeDirection === "rtl" ? "transform -scale-x-100" : ""
                  }`}
                />
              )}
            </div>
            <p className="dark:text-color_v1_dark">
              {translate("text_editor")}
            </p>
          </div>
        </Link>
      </div>
      <HeaderForm
        formType={"edit"}
        submitHandlerParent={handleHeadingTextSubmit}
        handleDelete={() => setIsModalOpen(true)}
        isLoading={subLoader}
        preHeaderData={prevData}
      />
    </>
  );
};

export default EditHeader;
